import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles, DialogTitle, Dialog, Slide } from '@material-ui/core';




const styles = theme => ({


});



function Transition(props) {
    return <Slide direction="up" {...props} />;
}

class SuccessMessageModel extends Component {
    constructor(props) {
        super(props);

        this.state = {
            successmessage: true,


        };
    }

    handlClosesuccessmessage = () => {
        this.setState({ successmessage: false })
    }


    render() {
        const { classes, SuccessMessageText } = this.props;

        return (

            <div>
                <Dialog
                    open={this.state.successmessage}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={this.handlClosesuccessmessage}
                    aria-labelledby="alert-dialog-slide-title"
                    aria-describedby="alert-dialog-slide-description"
                >
                    <DialogTitle id="alert-dialog-slide-title">
                        <div className="alertIcon">✔️ <label>{SuccessMessageText} </label></div>
                    </DialogTitle>
                </Dialog>

            </div>
        )
    }


}
SuccessMessageModel.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SuccessMessageModel);